import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Nav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <ul className={styles.navigation}>
                {content.map((item, index) => (
                    <li key={index}>
                        <a href={item.url} target="_blank" title={item.title} rel="noreferrer">
                            {item.title}
                        </a>
                    </li>
                ))}
            </ul>
        );
    }
}

export default errorBoundary(Nav);
